import { Link } from 'react-router-dom';
import 'materialize-css';
import {Navbar, Icon, NavItem} from 'react-materialize';

import '../styles/main.css'
import Logo from '../assets/logo.png'

export default function nav() {
    return (
        <div style={{position:'sticky', top: '0', zIndex: '1'}}>
          <Navbar
            alignLinks="right"
            brand={<Link to='/' ><img src={Logo} alt='logo' className='logo' /></Link>}
            id="mobile-nav"
            className='navbar'
            menuIcon={<Icon className='hamburger-icon' >menu</Icon>}
            options={{
              draggable: true,
              edge: 'left',
              inDuration: 250,
              onCloseEnd: null,
              onCloseStart: null,
              onOpenEnd: null,
              onOpenStart: null,
              outDuration: 200,
              preventScrolling: true
            }}
          >
          <Link to='/shop' className='nav-items'>shop</Link>
          <Link to='/cart' className='nav-items'>cart</Link> 
          <Link to='/login' className='nav-items'>login</Link>
          </Navbar>
        </div>
    )
}


